import { useState } from 'react';
import { SearchIcon } from '../../assets/react-icons/';
import { filter, map, findIndex, find, some, isEmpty } from 'lodash';
import { FUSE_OPTIONS, idFormatter, truncate, orderByKey } from '../../utils';
import Fuse from 'fuse.js';
import { Checkbox, Button } from 'react-md';
import './FilterSelection.scss';

const FilterSelection = ({
  onApply,
  variableKey,
  label,
  labelKey = 'name',
  data,
  formatter,
  enableSearch
}) => {
  const [initialData, setInitialData] = useState(data);
  const [searchTerm, setSearchTerm] = useState('');

  const handleApply = (e) => {
    e.stopPropagation();

    const selected = map(filter(initialData, { selected: true }), (item) => item.id);
    const applied = selected.length ? selected : null;

    onApply({ [variableKey]: applied });
  };

  const handleOnChangeCheckbox = (v, item) => {
    const index = findIndex(initialData, obj => obj.id === item.id);
    const newList = [...initialData];
    newList[index].selected = v;

    setInitialData(newList);
  };

  const handleOnChangeSelectAll = (checked) => setInitialData(initialData.map(({ name, id }) => ({ name, id, selected: checked })));

  const isAllSelected = !some(initialData, ['selected', false]);

  const createList = () => {
    if (enableSearch) {
      const searchList = initialData;
      const fuse = new Fuse(searchList, FUSE_OPTIONS);
      const results = fuse.search(searchTerm);
      const filteredWithCheckState = results.map(result => find(initialData, ['id', result.item.id]));

      return searchTerm === '' ? initialData : filteredWithCheckState;
    }

    return initialData;
  };

  const LIST = orderByKey(createList(), 'name', 'asc');

  return (
    <div className="filter-selection">
      {
        enableSearch &&
        <div className="filter-selection-search" >
          <input type="text" onChange={(e) => setSearchTerm(e.target.value)} placeholder="Search" />
          <span>
            <SearchIcon color="#949494" width={20} />
          </span>
        </div>
      }
      {!isEmpty(LIST) &&
        <Checkbox
          id={`${idFormatter(label)}-top-control-select`}
          className="ph-checkbox top-control"
          label="Select All"
          name="select-all"
          onChange={(e) => handleOnChangeSelectAll(e.currentTarget.checked)}
          checked={isAllSelected}
          iconAfter
        />
      }
      <div className="filter-selection-list-container">
        <ul className="filter-selection-list">
          {LIST && LIST.map((item, index) => (
            <li
              title={item[labelKey]}
              key={`${item[labelKey]}-${index}`}
            >
              <Checkbox
                id={`${idFormatter(label)}-check-input-${index}`}
                className="ph-checkbox"
                name={`${idFormatter(label)}-check-input-${index}`}
                label={formatter ? formatter(item[labelKey]) : truncate(item[labelKey], 42)}
                title={item[labelKey]}
                onChange={(e) => handleOnChangeCheckbox(e.currentTarget.checked, item)}
                checked={item.selected}
                iconAfter
              />
            </li>
          ))}
        </ul>
      </div>
      <div className="filter-selection-action-container">
        <Button
          disabled={LIST.length === 0}
          id={`${idFormatter(label)}-filter-apply`}
          className="filter-selection-apply-button"
          themeType="contained"
          theme="primary"
          onClick={handleApply}
        >
          Apply
        </Button>
      </div>
    </div>
  );
};

export default FilterSelection;
